module.exports = __webpack_public_path__ + "img/play.d16aad83.svg";